import { useState } from "react";

const API_BASE = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

function ChatbotPopup({ onClose }) {
  const [messages, setMessages] = useState([
    {
      role: "bot",
      text: "Xin chào 👋 Tôi có thể hỗ trợ các câu hỏi về sức khỏe thai kỳ.",
    },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userId = localStorage.getItem("user_id");
    if (!userId) {
      setMessages((prev) => [
        ...prev,
        { role: "bot", text: "Vui lòng đăng nhập để sử dụng trợ lý." },
      ]);
      return;
    }

    const userMessage = { role: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/ask-with-scheduling`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          user_id: parseInt(userId),
          message: userMessage.text 
        }),
      });

      const data = await res.json();

      let botResponse = data.answer || "Tôi đang gặp sự cố.";
      
      // If appointment was created, add a note
      if (data.appointment_created) {
        botResponse += "\n\n✅ Đã tạo lịch hẹn thành công! Bạn có thể xem trong trang Lịch hẹn.";
      }

      setMessages((prev) => [
        ...prev,
        { role: "bot", text: botResponse },
      ]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        {
          role: "bot",
          text: "Không thể kết nối máy chủ. Vui lòng thử lại sau.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const renderBoldText = (text) => {
  return text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
};

  return (
<div
  style={{
    position: "fixed",
    bottom: "96px",
    right: "24px",
    width: "320px",
    maxHeight: "70vh",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
    zIndex: 1000,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  }}
>

      <div
        style={{
          padding: "12px",
          background: "#ff6f91",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Trợ lý thai kỳ</span>
        <button
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            color: "white",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          ✕
        </button>
      </div>

<div
  style={{
    padding: "12px",
    flex: 1,
    overflowY: "auto",
    fontSize: "14px",
    background: "#fafafa",
  }}
>
        {messages.map((m, i) => (
          <div
            key={i}
            style={{
              marginBottom: "8px",
              textAlign: m.role === "user" ? "right" : "left",
            }}
          >
            <span
              style={{
                display: "inline-block",
                padding: "8px 12px",
                borderRadius: "12px",
                background: m.role === "user" ? "#ffe0e9" : "#f1f1f1",
              }}
            >
              <span
  style={{
    display: "inline-block",
    padding: "8px 12px",
    borderRadius: "12px",
    background: m.role === "user" ? "#ffe0e9" : "#f1f1f1",
  }}
  dangerouslySetInnerHTML={{
    __html: renderBoldText(m.text),
  }}
/>
            </span>
          </div>
        ))}
        {loading && <div>Đang trả lời…</div>}
      </div>

      <div style={{ padding: "8px", display: "flex" }}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          placeholder="Nhập câu hỏi…"
          style={{ flex: 1, padding: "8px" }}
        />
        <button onClick={sendMessage} style={{ marginLeft: "6px" }}>
          Gửi
        </button>
      </div>
    </div>
  );
}

export default ChatbotPopup;
